<template>
  <div class="home">

    <!-- Lista dos apps -->
    <span class="titulo-section" style="text-align: center;">APLICATIVOS KLAUS</span>
    <b-container class="lista-de-apps my-4">
      <Card v-for="(app, index) in listaApps" :titulo="app.titulo" :descricao="app.descricao" :icone="app.icone"
        :link="app.icone" :standalone="app.standalone" :index="index" :key="app.titulo" :extensao="app.extensao" :qrcode="app.qrcode" />
    </b-container>

    <!-- Modal de download -->
    <modal-download-suite @fechar-modal="fecharModal" :visibilidade="isModalVisivel" />
  </div>
</template>

<script>
import Card from "../components/Card";

import ModalDownloadSuite from "../components/ModalDownloadSuite";
import mixin from "../mixins/mixin";
export default {
  name: "Home",
  components: { Card, ModalDownloadSuite, ModalDownloadSuite },
  mixins: [mixin],
  data() {
    return {
      listaApps: [
        {
          titulo: "Klaus A1",
          descricao:
            "Faça o download de documentos fiscais da SEFAZ para sua máquina sincronizando-os diretamente para a Klaus e seu PC",
          icone: "klaus-a1",
          extensao: "svg",
          standalone: "https://fiscdn.klaus.com.br/standalone/klaus-a1.exe"
        },
        {
          titulo: "Klaus A3",
          descricao:
            "Faça o download de documentos fiscais da SEFAZ para sua máquina utilizando seu token A3",
          icone: "klaus-a3",
          extensao: "svg",
          standalone: "https://fiscdn.klaus.com.br/standalone/klaus-a3.exe"
        },
        {
          titulo: "Robô Klaus",
          descricao:
            "Envie notas de saída do seu PC para nuvem Klaus com facilidade. Basta selecionar a pasta e o resto a gente faz",
          icone: "robo-klaus",
          extensao: "svg",
          standalone: "https://fiscdn.klaus.com.br/standalone/robo-klaus.exe"
        },
        {
          titulo: "Central Klaus",
          descricao:
            "Baixe as notas que estão na nuvem Klaus direto para seu computador de forma organizada",
          icone: "central-klaus",
          extensao: "svg",
          standalone: "https://fiscdn.klaus.com.br/standalone/klaus-cd.exe"
        },
        {
          titulo: "Apple App Store",
          descricao:
            "Visualize, gerencie e manifeste suas notas diretamente do seu dispositivo móvel da Apple!",
          icone: "app-store-ios",
          extensao: "svg",
          standalone: "https://apps.apple.com/br/app/klaus-fiscal-mobile/id1576713107",
          qrcode: true,
        },
        {
          titulo: "Google Play Store",
          descricao:
            "Visualize, gerencie e manifeste suas notas diretamente do seu dispositivo móvel da Android!",
          icone: "google-play",
          extensao: "svg",
          standalone: "https://play.google.com/store/apps/details?id=br.com.klausfiscal.kmobile&hl=pt",
          qrcode: true,
        },
        {
          titulo: "KPDF View",
          descricao:
            "Visualize como PDF (DANFE, DACTE, DACTE-OS, etc.) os XMLs de documentos fiscais",
          icone: "kpdf",
          extensao: "png",
          standalone: "https://fiscdn.klaus.com.br/standalone/kpdf.exe"
        },
        {
          titulo: "Componente NFSe",
          descricao:
            "Habilite novas prefeituras nos aplicativos Klaus A1 e Klaus A3",
          icone: "componente-nfse",
          extensao: "png",
          standalone: "https://fiscdn.klaus.com.br/suite-klaus-container/packages/componente-nfse.zip"
        },
        {
          titulo: "Robô Klaus Lite",
          descricao: "Envie notas de saída do seu PC para nuvem Klaus com facilidade. Basta selecionar a pasta e o resto a gente faz",
          icone: "robo-lite",
          extensao: "png",
          standalone: "https://fiscdn.klaus.com.br/standalone/krobo-lite.exe"
        }
      ],
    };
  },
};
</script>
<style scoped>
h1 {
  font-size: 1.8rem;
}

.logo-klaus-suite {
  width: 20%;
  min-width: 100px;
}

.lista-de-apps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  max-width: 990px;
  gap: 35px;
}
</style>
